/* tslint:disable */
/* eslint-disable */
export enum CustomerTypeEnum {
  NotSet = 0,
  Annonsering = 1,
  Butik = 2
}
